(function () {
  "use strict";

  /* =========================================================
     CART DRAWER ENHANCEMENTS  (Oath Jewelry)
     Self-contained. Injects a free-shipping bar, trust row,
     aria-live regions, and a clearer checkout label into the
     existing .cart-drawer (markup lives in layout/theme.liquid,
     logic lives in theme.js -> openCartDrawer / loadCart).

     CONFIG:
     FREE_SHIP_THRESHOLD = free-shipping minimum in USD CENTS.
       0   -> shipping is free on every order. Shows a reassurance
              line, no progress bar. (Matches current Product schema,
              which advertises free U.S. shipping.)
       >0  -> shows a "Spend $X more for free shipping" progress bar.
              Example: 7500 = $75.00 threshold.
     ========================================================= */
  var FREE_SHIP_THRESHOLD = 0;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    var drawer = document.querySelector(".cart-drawer");
    if (!drawer) return;

    injectStyles();
    injectShipBar(drawer);
    injectTrustRow(drawer);
    enhanceSubtotal();
    relabelCheckout();

    refresh();
    watchCart();
  });

  function injectStyles() {
    if (document.getElementById("cart-enhance-styles")) return;
    var css =
      ".cart-ship-bar{padding:12px 16px;border-bottom:1px solid #eee;font-size:13px;color:#41617A;}" +
      ".cart-ship-bar .cart-ship-msg{display:block;margin-bottom:6px;font-weight:600;}" +
      ".cart-ship-track{height:6px;background:#eee;border-radius:99px;overflow:hidden;}" +
      ".cart-ship-fill{height:100%;background:#557B97;width:0;transition:width .3s ease;}" +
      ".cart-ship-bar.is-unlocked{color:#2e7d4f;}" +
      ".cart-ship-bar.is-unlocked .cart-ship-fill{background:#2e7d4f;}" +
      ".cart-trust{display:flex;gap:14px;justify-content:center;flex-wrap:wrap;padding:12px 16px 0;font-size:12px;color:#555;}" +
      ".cart-trust span{display:inline-flex;align-items:center;gap:5px;}" +
      ".cart-trust svg{width:14px;height:14px;flex:none;}";
    var s = document.createElement("style");
    s.id = "cart-enhance-styles";
    s.textContent = css;
    document.head.appendChild(s);
  }

  function injectShipBar(drawer) {
    if (document.getElementById("CartShipBar")) return;
    var content = document.getElementById("CartDrawerContent");
    var bar = document.createElement("div");
    bar.className = "cart-ship-bar";
    bar.id = "CartShipBar";
    bar.hidden = true;
    bar.setAttribute("aria-live", "polite");
    bar.innerHTML =
      '<span class="cart-ship-msg"></span>' +
      '<div class="cart-ship-track"><div class="cart-ship-fill"></div></div>';
    if (content && content.parentNode) {
      content.parentNode.insertBefore(bar, content);
    } else {
      drawer.appendChild(bar);
    }
  }

  function injectTrustRow(drawer) {
    if (document.getElementById("CartTrust")) return;
    var footer = document.getElementById("CartFooter") || drawer;
    var row = document.createElement("div");
    row.className = "cart-trust";
    row.id = "CartTrust";
    row.innerHTML =
      "<span>" + lockSvg() + "Secure checkout</span>" +
      "<span>" + returnSvg() + "30-day returns</span>" +
      "<span>" + truckSvg() + "Ships in 1-2 days</span>";
    footer.appendChild(row);
  }

  function enhanceSubtotal() {
    var s = document.getElementById("CartSubtotal");
    if (s) s.setAttribute("aria-live", "polite");
  }

  function relabelCheckout() {
    var c = document.querySelector(".cart-checkout");
    if (c && c.textContent.trim() === "Next step") c.textContent = "Checkout";
  }

  function cartHasItems() {
    var countEl = document.querySelector("[data-cart-count]");
    if (countEl) {
      return (parseInt((countEl.textContent || "0").replace(/[^0-9]/g, ""), 10) || 0) > 0;
    }
    var empty = document.getElementById("CartEmpty");
    if (empty && getComputedStyle(empty).display !== "none") return false;
    return document.querySelectorAll("#CartDrawerContent .cart-item").length > 0;
  }

  function getSubtotalCents() {
    var el = document.getElementById("CartSubtotal");
    if (!el) return 0;
    var n = parseFloat((el.textContent || "0").replace(/[^0-9.]/g, ""));
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function money(cents) {
    return "$" + (cents / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function refresh() {
    var bar = document.getElementById("CartShipBar");
    if (!bar) return;

    if (!cartHasItems()) {
      bar.hidden = true;
      return;
    }
    bar.hidden = false;

    var msg = bar.querySelector(".cart-ship-msg");
    var fill = bar.querySelector(".cart-ship-fill");
    var track = bar.querySelector(".cart-ship-track");

    if (FREE_SHIP_THRESHOLD <= 0) {
      bar.classList.add("is-unlocked");
      msg.textContent = "Free U.S. shipping on every order";
      if (track) track.style.display = "none";
      return;
    }
    if (track) track.style.display = "";

    var cents = getSubtotalCents();
    if (cents >= FREE_SHIP_THRESHOLD) {
      bar.classList.add("is-unlocked");
      msg.textContent = "You have unlocked free U.S. shipping";
      fill.style.width = "100%";
    } else {
      bar.classList.remove("is-unlocked");
      msg.textContent = "Spend " + money(FREE_SHIP_THRESHOLD - cents) + " more for free U.S. shipping";
      fill.style.width = Math.min(100, Math.round((cents / FREE_SHIP_THRESHOLD) * 100)) + "%";
    }
  }

  function watchCart() {
    var counters = document.querySelectorAll("[data-cart-count]");
    if (counters.length) {
      var obs = new MutationObserver(function () { refresh(); });
      counters.forEach(function (c) {
        obs.observe(c, { childList: true, characterData: true, subtree: true });
      });
    }
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest(".js-cart-icon")) {
        setTimeout(refresh, 60);
      }
    });
    if (typeof window.openCartDrawer === "function") {
      var orig = window.openCartDrawer;
      window.openCartDrawer = function () {
        var r = orig.apply(this, arguments);
        setTimeout(refresh, 60);
        return r;
      };
    }
  }

  function lockSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="#557B97" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>';
  }
  function returnSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="#557B97" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg>';
  }
  function truckSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="#557B97" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>';
  }

})();
